import { languageReducer } from './Language.slice'

export default languageReducer
